<template>
  <div class="layout-center layout-center--narrow">
    <div class="layout-center__content">
      <div class="layout-center__viewport">
        <div class="task-details-header">
          <router-link
            class="task-details-header__close"
            :to="pageData.plan"
          >
            <UseSvg
              class="icon"
              name="close"
            />
          </router-link>
          <div class="task-details-header__title typo-small-title">
            {{ task ? task.point.name : '' }}: <strong>{{ task ? task.label : '' }}</strong>
          </div>
        </div>

        <div class="menu">
          <ul class="menu__items">
            <li
              v-for="item in menuItems"
              :key="item.label"
              class="menu-item typo-small"
            >
              <router-link
                class="menu-item__link"
                exactActiveClass="menu-item__link--active"
                :to="item.to"
              >
                <div class="menu-item__label">
                  {{ item.label }}
                </div>
              </router-link>
            </li>
          </ul>
        </div>

        <router-view />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, provide, ref } from 'vue';
import I18n from 'i18n-js';

import UseSvg from '@/components/generic/use_svg.vue';
import useAjax from '@/functions/use_ajax';

const props = defineProps({
  organisationId: { type: String, required: true },
  operationId: { type: String, required: false, default: null },
  equipmentId: { type: String, required: false, default: null },
  planId: { type: String, required: true },
  pointId: { type: String, required: true },
  taskId: { type: String, required: true },
});

const ajax = useAjax();

const task = ref(null);
const results = ref(null);

const pageData = computed(() => {
  const type = props.equipmentId ? 'equipmentData' : 'operationData';
  const data = {
    equipmentData: {
      task: 'equipmentTask',
      results: 'equipmentTaskResults',
      comments: 'equipmentTaskComments',
      taskPath: `/organisations/${props.organisationId}/equipment/${props.equipmentId}/monitoring_plans/plans/${props.planId}/points/${props.pointId}/tasks/${props.taskId}`,
      plan: { name: 'equipmentPlan', params: { scope: 'plans' } },
    },
    operationData: {
      task: 'task',
      results: 'taskResults',
      comments: 'taskComments',
      taskPath: `/organisations/${props.organisationId}/operations/${props.operationId}/monitoring_plans/plans/${props.planId}/points/${props.pointId}/tasks/${props.taskId}`,
      plan: { name: 'plan', params: { scope: 'plans' } },
    },
  };
  return data[type];
});

const menuItems = computed(() => [
  {
    label: 'Task',
    to: { name: pageData.value.task },
  },
  {
    label: pluralize('activerecord.models.monitoring_plans/task_result', task.value?.results_count || null),
    to: { name: pageData.value.results },
  },
  {
    label: pluralize('activerecord.attributes.monitoring_plans/task_result.comment', task.value?.comments_count || null),
    to: { name: pageData.value.comments },
  }
]);

provide('task', task);
provide('results', results);
provide('path', `${pageData.value.taskPath}/task_results`);

onMounted(async() => {
  task.value = await load(pageData.value.taskPath);
  results.value = await load(`${pageData.value.taskPath}/task_results`);
});

async function load(url) {
  let { ok, data } = await ajax(url);

  if (ok) {
    return data;
  }
}

function pluralize(key, count) {
  if (count === null) return I18n.t(key, { count: 9999 });

  return `${count} ${I18n.t(key, { count })}`;
}
</script>
